type ParsedBridgeClient = {
	localClientId: string;
	externalClientId: string;
};

/**
 * Safely parses the bridgeClient parameter to extract the dbClientId for Rovo receiver.
 * Returns undefined if parsing fails or if bridgeClient is not provided.
 */
export const parseRovoReceiverId = (bridgeClient?: string): string | undefined => {
	if (!bridgeClient) {
		return undefined;
	}

	try {
		const bridgeClientData = JSON.parse(bridgeClient) as ParsedBridgeClient;
		const dbClientId = bridgeClientData?.localClientId;

		// Return undefined for null or undefined values, but keep empty strings
		return dbClientId === null || dbClientId === undefined ? undefined : dbClientId;
	} catch {
		// Silently swallow parsing errors
		return undefined;
	}
};
